<template>
  <b-container fluid>
    <b-row>
      <b-col xs="12" md="12" lg="12" xl="12">
        <h5 class="mb-0">{{ $t("Харажат хисобот") }}</h5>
      </b-col>

      <!-- FILTERS -->
      <b-col lg="2" md="4" class="my-1">
        <label>{{ $t("Вақт") }} 1</label>
        <input class="form-control" type="date" v-model="datas.date1" />
      </b-col>
      <b-col lg="2" md="4" class="my-1">
        <label>{{ $t("Вақт") }} 2</label>
        <input class="form-control" type="date" v-model="datas.date2" />
      </b-col>
      <b-col lg="3" md="4" class="my-1">
        <label>{{ $t('Склад') }}</label>
        <v-select :options="skladlist" v-model="selectedSklad" :reduce="s => s.id" label="name" :clearable="true" placeholder="Barchasi"></v-select>
      </b-col>
      <b-col lg="3" md="6" class="my-1 filt">
        <label>{{ $t('Тўлов тури') }}</label>
        <v-select class="form-control-sm md-input filt" :options="paytypelist" v-model="filtertype" :clearable="false"
          multiple :reduce="name => name.id" label="name"></v-select>
      </b-col>
      <b-col lg="2" md="6" class="my-1">
        <br>
        <button type="button" class="btn mybtn" @click="Send()">{{ $t("Кўриш") }}</button>
        <button type="button" class="btn mybtn" @click="downloadExl">
          <b-icon icon="cloud-download"></b-icon>
        </button>
        <button type="button" class="btn mybtn" @click="Print()">
          <b-icon icon="printer"></b-icon>
        </button>
      </b-col>

    </b-row>

    <!-- TOTALS SUMMARY — full width -->
    <div class="totals-card" v-if="results.length > 0">
      <div class="total-item total-main">
        <div class="t-label">{{ $t("Жами") }}</div>
        <div class="t-value">{{ grandTotal | numFormats }}</div>
      </div>
      <div class="total-item" v-for="pt in visiblePayTypes" :key="pt.id">
        <div class="t-label">{{ pt.name }}</div>
        <div class="t-value">{{ grandByPayType(pt.id) | numFormats }}</div>
      </div>
    </div>

    <h2 v-if="empty == true" class="empty-box">{{ $t('Операция йўқ') }}</h2>

    <!-- TABLE — full width, below totals -->
    <div class="x-table-wrap" id="tableId">
      <table class="x-table">
        <colgroup>
          <col class="c-name">
          <col class="c-date">
          <col class="c-comment">
          <col class="c-money" v-for="pt in visiblePayTypes" :key="'c-' + pt.id">
          <col class="c-total">
        </colgroup>
        <thead>
          <tr>
            <th>{{ $t("Номи") }}</th>
            <th>{{ $t("Вақт") }}</th>
            <th>Комментарий</th>
            <th v-for="pt in visiblePayTypes" :key="pt.id" class="th-right">{{ pt.name }}</th>
            <th class="th-right total-col">{{ $t("Жами") }}</th>
          </tr>
        </thead>
        <tbody v-for="row in flatRows" :key="row.key" :class="row.cls + '-body'">
          <tr v-if="row.type === 'sklad'" class="sklad-row">
            <td colspan="3"><b>{{ row.label }}</b></td>
            <td v-for="pt in visiblePayTypes" :key="pt.id" class="num">
              {{ sumFromPayTypes(row.pay_types, pt.id) | numFormats }}
            </td>
            <td class="num total-col"><b>{{ row.summa | numFormats }}</b></td>
          </tr>
          <tr v-else-if="row.type === 'cat'" class="cat-row">
            <td colspan="3">{{ row.label }}</td>
            <td v-for="pt in visiblePayTypes" :key="pt.id" class="num">
              {{ sumFromPayTypes(row.pay_types, pt.id) | numFormats }}
            </td>
            <td class="num total-col">{{ row.summa | numFormats }}</td>
          </tr>
          <tr v-else class="item-row">
            <td class="cat-cell">{{ row.cat_name }}</td>
            <td class="date-cell">{{ Dates(row.datetime) }}</td>
            <td class="comment-cell">{{ row.comment || '—' }}</td>
            <td v-for="pt in visiblePayTypes" :key="pt.id" class="num">
              <span v-if="row.pay_type && row.pay_type.id === pt.id">{{ row.summa | numFormats }}</span>
            </td>
            <td class="num total-col">{{ row.summa | numFormats }}</td>
          </tr>
        </tbody>
        <tfoot v-if="results.length > 0">
          <tr class="total-row">
            <td colspan="3"><b>{{ $t("ЖАМИ") }}</b></td>
            <td v-for="pt in visiblePayTypes" :key="pt.id" class="num">
              <b>{{ grandByPayType(pt.id) | numFormats }}</b>
            </td>
            <td class="num total-col"><b>{{ grandTotal | numFormats }}</b></td>
          </tr>
        </tfoot>
      </table>
    </div>
  </b-container>
</template>

<script>
var XLSX = require("xlsx");
var FileSaver = require("file-saver");
import { print } from "../../../components/mixins/print.js";

export default {
  data() {
    return {
      filtertype: [],      // tanlangan pay_type id lari
      paytypelist: [],
      skladlist: [],
      selectedSklad: null,
      datas: {
        date1: new Date().toISOString().slice(0, 8) + "01",
        date2: new Date().toISOString().slice(0, 10)
      },
      results: [],
      empty: false,
    };
  },
  mixins: [print],
  computed: {
    visiblePayTypes() {
      if (!this.filtertype || this.filtertype.length === 0) return this.paytypelist;
      const set = new Set(this.filtertype.map(Number));
      return this.paytypelist.filter(p => set.has(Number(p.id)));
    },
    grandTotal() {
      return this.results.reduce((s, r) => s + Number(r.summa || 0), 0);
    },
    flatRows() {
      const out = [];
      this.results.forEach((s, i) => {
        out.push({ key: 's' + i, type: 'sklad', cls: 'sklad', label: s.sklad, summa: s.summa, pay_types: s.pay_types });
        (s.base || []).forEach((b, j) => {
          out.push({ key: 'c' + i + '-' + j, type: 'cat', cls: 'cat', label: b.name, summa: b.summa, pay_types: b.pay_types });
          (b.items || []).forEach((it, k) => {
            out.push({
              key: 'i' + i + '-' + j + '-' + k,
              type: 'item',
              cls: 'item',
              cat_name: b.name,
              datetime: it.datetime,
              comment: it.comment,
              summa: it.summa,
              pay_type: it.pay_type,
            });
          });
        });
      });
      return out;
    }
  },
  mounted() {
    this.Paytypelist();
    this.Skladlist();
  },
  methods: {
    Paytypelist() {
      axios.get("api/v1/pay-type").then(res => {
        this.paytypelist = res.data || [];
        this.filtertype = this.paytypelist.map(p => p.id);
      });
    },
    Skladlist() {
      axios.get("api/v1/sklads").then(res => {
        this.skladlist = res.data || [];
        if (this.skladlist.length === 1) {
          this.selectedSklad = this.skladlist[0].id;
        }
      }).catch(() => { this.skladlist = []; });
    },
    sumFromPayTypes(arr, payTypeId) {
      if (!Array.isArray(arr)) return 0;
      const f = arr.find(p => Number(p.id) === Number(payTypeId));
      return f ? f.summa : 0;
    },
    grandByPayType(payTypeId) {
      return this.results.reduce((s, r) => s + this.sumFromPayTypes(r.pay_types, payTypeId), 0);
    },
    Send() {
      const datas = {
        datetime1: parseInt(new Date(this.datas.date1).valueOf().toString().slice(0, 10)),
        datetime2: parseInt(new Date(this.datas.date2).valueOf().toString().slice(0, 10)) + 86399,
        sklad_id: this.selectedSklad || undefined,
      };
      axios.post("api/v1/report/kassa-order", datas).then(res => {
        const data = res.data || [];
        this.empty = data.length === 0;
        this.results = data;
      });
    },
    downloadExl() {
      this.$store.state.xls = true;
      setTimeout(() => {
        const wb = XLSX.utils.table_to_book(document.getElementById("tableId"));
        const wopts = { bookType: "xlsx", bookSST: false, type: "binary" };
        const wscols = Array(3 + this.visiblePayTypes.length + 1).fill({ width: 15 });
        wb.Sheets.Sheet1['!cols'] = wscols;
        const wbout = XLSX.write(wb, wopts);
        FileSaver.saveAs(
          new Blob([this.s2ab(wbout)], { type: "application/octet-stream;charsetted=utf-8" }),
          new Date().toISOString().slice(0, 10) + "_xarajat.xlsx"
        );
        setTimeout(() => { this.$store.state.xls = false; }, 2000);
      }, 500);
    },
    s2ab(s) {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      for (let i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    },
  }
};
</script>

<style>
.filt .vs__selected { position: inherit !important; }
</style>
<style scoped>
.x-table-wrap {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: auto;
  max-height: 70vh;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.03);
}
.x-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 13px;
}
.x-table col.c-date    { width: 140px; }
.x-table col.c-money   { width: 130px; }
.x-table col.c-total   { width: 140px; }
.x-table col.c-name    { width: 180px; }
.x-table col.c-comment { width: auto; }

.x-table thead th {
  background: #ffffff !important;
  color: #475569 !important;
  font-weight: 700;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 12px;
  border: 1px solid #e2e8f0;
  text-align: left;
  position: sticky;
  top: 0;
  z-index: 2;
}
.x-table th.th-right,
.x-table td.num {
  text-align: right;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.x-table td {
  padding: 10px 12px;
  border: 1px solid #e2e8f0;
  color: #334155;
  vertical-align: middle;
}
.sklad-row td {
  background: #eef2ff;
  font-weight: 700;
  color: #1e293b;
  border-top: 2px solid #a142f4;
}
.cat-row td {
  background: #f8fafc;
  font-weight: 600;
  color: #475569;
}
.item-row:hover td { background: #fdf2f8; }
.cat-cell { color: #7c3aed; font-weight: 600; font-size: 12px; }
.x-table tfoot .total-row td {
  background: #a142f4 !important;
  color: white !important;
  font-weight: 800;
  font-size: 14px;
  border-top: 2px solid #7c3aed;
  position: sticky;
  bottom: 0;
  z-index: 2;
}
.x-table tfoot .total-row td.total-col {
  background: #7c3aed !important;
  color: white !important;
}
.date-cell { color: #64748b; font-size: 12px; white-space: nowrap; }
.comment-cell { color: #64748b; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.empty-box { background: #fee2e2; color: #991b1b; text-align: center; padding: 20px; border-radius: 12px; font-size: 18px; font-weight: 700; }

.totals-card {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 10px;
  padding: 12px;
  background: white;
  border-radius: 14px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  border: 1px solid #f1f5f9;
  margin-bottom: 10px;
}
.total-item {
  background: #f8fafc;
  border-radius: 10px;
  padding: 12px 16px;
  border: 1px solid #e2e8f0;
  min-width: 0;
}
.total-item.total-main {
  background: linear-gradient(135deg, #be185d, #db2777);
  color: white;
  border: none;
}
.t-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  opacity: 0.8;
}
.t-value {
  font-size: 17px;
  font-weight: 800;
  margin-top: 4px;
  font-variant-numeric: tabular-nums;
}
.total-col { background: #fef3c7 !important; font-weight: 700; color: #92400e; font-variant-numeric: tabular-nums; }
</style>
